module.exports = __webpack_public_path__ + "static/media/ContactSVG.3f510ae2.svg";